import styled from 'styled-components';
import { ButtonHTMLAttributes } from 'react';
import buttonMixin, { ButtonMixinProps } from './buttonMixin';

type Props = ButtonMixinProps & {
  type?: ButtonHTMLAttributes<any>['type'];
};

const Button = styled.button.attrs(({ type }) => ({
  type: type || 'button',
}))<Props>`
  ${buttonMixin}
`;

export default Button;
